export default "__VITE_ASSET__BJGTSfAS__"